import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { FormValidators } from '@app/providers/utils/form-validators';
import { Subject, combineLatest, map, shareReplay, takeUntil } from 'rxjs';
import { PledgeRead } from '../../definition/interface/Pledge';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

@Component({
  selector: 'joint-ownership-form',
  templateUrl: './joint-ownership-form.component.html',
  styleUrls: ['./joint-ownership-form.component.scss'],
  standalone: false,
})
export class JointOwnershipFormComponent implements OnInit, OnChanges {
  jointOwnershipForm: FormArray;
  sessionConsultant: boolean;
  pledge: PledgeRead;
  @Input() formGroup: UntypedFormGroup;

  @Input() derrors: any = undefined;
  maritalSituations: any[] = [
    { id: 'SINGLE', value: 'Célibataire' },
    { id: 'MARRIED', value: 'Marié' },
    { id: 'CIVILPARTNER', value: 'Pacsé' },
    { id: 'DIVERCED', value: 'Divorcé' },
    { id: 'WIDOWER', value: 'Veuf/Veuve' },
  ];
  enrollmentOffices: any = [
    { id: 'RG', value: 'Régime général (CPAM)' },
    { id: 'RA', value: 'Régime agricole' },
    { id: 'RSI', value: 'RSI ou caisse des indépendants' },
    { id: 'SCNF', value: 'SNCF' },
    { id: 'RATP', value: 'RATP' },
    { id: 'MC', value: 'Militaires de carrière' },
    { id: 'CFE', value: "Caisse des Français de l'étranger" },
    { id: 'MGEN', value: "Mutuelle Générale de l'Éducation Nationale (MGEN)" },
    { id: 'MNH', value: 'Mutuelle Nationale des Hospitaliers (MNH)' },
  ];
  reference$;
  destroy$ = new Subject<void>();

  constructor(
    private controlContainer: ControlContainer,
    private referenceDao: ReferenceDao,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {}

  ngOnInit() {
    this.jointOwnershipForm = this.formGroup.get(
      'prestationJointOwnershipList',
    ) as UntypedFormArray;

    this.pledge = this.subscriptionFacade?.getPledge();
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;

    const combineLatestObservable = combineLatest([
      this.referenceDao.getCountries(),
      this.referenceDao.getDepartment(),
    ]);

    this.reference$ = combineLatestObservable.pipe(
      takeUntil(this.destroy$),
      map(([countries, departments]) => {
        return { countries, departments };
      }),
      shareReplay(1),
    );
  }

  addFields() {
    this.jointOwnershipForm.push(
      new FormGroup({
        firstname: new FormControl('', [Validators.required]),
        lastname: new FormControl('', [Validators.required]),
        birthdate: new FormControl(new Date('01/01/1970'), [
          Validators.required,
        ]),
        birthLocation: new FormControl('', [Validators.required]),
        birthZipCode: new FormControl('', [Validators.required]),
        nationality: new FormControl('', [Validators.required]),
        socialSecurityNumber: new FormControl(
          '',
          [
            !this.sessionConsultant ? Validators.required : null,
            FormValidators.socialSecurityNumber,
          ].filter(validator => validator !== null),
        ),
        enrollmentOffice: new FormControl(
          '',
          !this.sessionConsultant ? [Validators.required] : null,
        ),
        postalAddress: new FormControl('', [Validators.required]),
        phone: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required]),
        maritalSituation: new FormControl('', [Validators.required]),
        fiscalNumber: new FormControl(
          '',
          [
            !this.sessionConsultant ? Validators.required : null,
            Validators.minLength(9),
            Validators.maxLength(13),
          ].filter(validator => validator !== null),
        ),
      }),
    );

    this.jointOwnershipForm.markAsUntouched();
  }

  deleteFields(index) {
    this.jointOwnershipForm.removeAt(index);
  }

  ngOnChanges() {
    if (this.jointOwnershipForm)
      this.jointOwnershipForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
